import { Zap } from "lucide-react";

const ITEMS = [
  "GRATIS VERZENDING VANAF €50 IN NL & BE",
  "10.000 GRATIS GEL ORBS BIJ ELKE BLASTER",
  "VOOR 23:00 BESTELD = MORGEN IN HUIS",
  "100% VEILIG & NIET-TOXISCH",
  "30 DAGEN NIET GOED = GELD TERUG",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-strip" className="relative overflow-hidden border-y border-slate-800 bg-[#0D1320] py-4">
      <div className="flex w-max animate-marquee-slow gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-3 px-6 font-display text-xl tracking-widest text-slate-300 whitespace-nowrap"
              >
                <Zap className="w-4 h-4 text-[#00FF66]" />
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
